<template>
  <FormEmployee
    :jobTitle="jobTitle"
    :foots="foots"
    :divisions="divisions"
    :positions="positions"
    :jobLevel="jobLevel"
    :companies="companies"
    :gender="gender"
    :japaneseLevel="japaneseLevel"
    :workType="workType"
    :workShift="workShift"
    :skillSheet="skillSheet"
    :skill="skill"
    :experience="experience"
    :menuStatus="false"
    :selectedSkill="selectedSkill"
    :selectedExperience="selectedExperience"
    v-on:submitCreateEmployee="submitCreateEmployee"
  />
</template>

<script>
import FormEmployee from "@/components/Employees/FormEmployee.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateEmployee",
  metaInfo() {
    return {
      title: this.$t("page_title.page_employee_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    FormEmployee
  },

  data() {
    return {
      id: "",
      menuStatus: false,
      selectedSkill: [],
      selectedExperience: [],
    };
  },

  computed: {
    ...mapGetters({
      jobTitle: "commons/jobTitle",
      foots: "commons/foots",
      divisions: "commons/divisions",
      positions: "commons/positions",
      jobLevel: "commons/jobLevel",
      companies: "commons/companies",
      gender: "commons/gender",
      japaneseLevel: "commons/japaneseLevel",
      workType: "commons/workType",
      workShift: "commons/workShift",
      skillSheet: "skillsheet/skillSheet"
    })
  },

  async created() {
    await this.$store.dispatch("commons/getJobLevel");
     this.showSkillSheet();
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    async submitCreateEmployee(formData) {
      this.id = formData.getAll("id");
      this.setLoading(true);
      await this.$store
        .dispatch("employee/createEmployee", formData)
        .then(() => {
          let message = this.$t("employee.popup.create_employee_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: `/employees/detail/${this.id}` });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
     async showSkillSheet() {
      let employeeId = await this.$route.params.id;
      if (!employeeId) {
        await this.$store.dispatch("skillsheet/showSkillSheet", employeeId);
      }
      this.skill = this.skillSheet.skillCheckRank;
      this.experience = this.skillSheet.skillCheckExperience;
    //   this.selectedSkill = this.skillSheets.skillCheckRank;
    // this.selectedExperience = this.skillSheets.skillCheckExperience;
   },
    showMenuSkill() {
      this.menuStatus = !this.menuStatus;
    }
  }
};
</script>
